import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MedplumProvider } from '@medplum/react'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { medplum } from './services/medplum'
import { glassTheme } from './theme/glassTheme'
import { OnboardingProvider } from './context/OnboardingContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import './styles/main.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MedplumProvider medplum={medplum}>
      <MantineProvider theme={glassTheme} forceColorScheme="dark">
        <Notifications position="top-right" />
        <ErrorBoundary>
          <OnboardingProvider>
            <App />
          </OnboardingProvider>
        </ErrorBoundary>
      </MantineProvider>
    </MedplumProvider>
  </StrictMode>,
)
